import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { updateBranch, AddOrUpdateBranchApiModel, BranchModel } from "@tCentro/Services/CENAdminBranchService";

export interface UpdateBranchParameter extends HasOnSuccess<BranchModel>, HasOnError<string> {
    model: AddOrUpdateBranchApiModel;
}

type HandlerType = ApiHandler<UpdateBranchParameter, { apiResult: BranchModel }>;

export const UpdateBranch: HandlerType = async props => {
    try {
        const result = await updateBranch(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result as BranchModel); // ← cast to BranchModel
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to update branch");
        }
    }
};

export const chain = [UpdateBranch];
const updateBranchData = createHandlerChainRunner(chain, "updateBranchData");
export default updateBranchData;
